import React from "react";
import { FiEdit } from "react-icons/fi";
import { Schedule } from "types/device.types";
import {
  SchedulesContainer,
  SchedulesTitle,
  SchedulesList,
  ScheduleItem,
  ScheduleLabel,
  ScheduleTime,
  ScheduleSpeed,
  ScheduleEditIcon,
} from "styles/devices/deviceSchedules.styles";

interface SchedulesPanelProps {
  schedules: Schedule[];
  formatTime: (timeInSeconds: string) => string;
  handleEditSchedule: (schedule: Schedule, index: number) => void;
  isLoading?: boolean;
}

const SchedulesPanel: React.FC<SchedulesPanelProps> = ({
  schedules,
  formatTime,
  handleEditSchedule,
  isLoading = false,
}) => {
  return (
    <SchedulesContainer>
      <SchedulesTitle>
        Schedules{" "}
        {isLoading && (
          <small style={{ fontSize: "12px", color: "#aaa" }}>
            (Updating...)
          </small>
        )}
      </SchedulesTitle>
      <SchedulesList>
        {schedules.map((schedule, index) => {
          // Schedule display format depends on if it's from the device object or shadow
          const onTime =
            typeof schedule.on === "string" && schedule.on.includes(":")
              ? schedule.on.substring(0, 5)
              : formatTime(schedule.on.toString());
          const offTime =
            typeof schedule.off === "string" && schedule.off.includes(":")
              ? schedule.off.substring(0, 5)
              : formatTime(schedule.off.toString());

          return (
            <ScheduleItem
              key={index}
              onClick={() => handleEditSchedule(schedule, index)}
            >
              <ScheduleLabel>Timer {index + 1}</ScheduleLabel>
              <ScheduleTime>
                {onTime} - {offTime}
              </ScheduleTime>
              <ScheduleSpeed>Speed: {schedule.speed}</ScheduleSpeed>
              <ScheduleEditIcon>
                <FiEdit size={14} />
              </ScheduleEditIcon>
            </ScheduleItem>
          );
        })}
        {schedules.length === 0 && <p>No schedules configured</p>}
      </SchedulesList>
    </SchedulesContainer>
  );
};

export default SchedulesPanel;
